<template>
  <div class="p-2 p-md-0 h-100">
    <div class="p-3 p-md-0 location-card h-100 bg-white">
      <div class="p-relative">
        <p class="font-weight-bold d-none d-md-block position-absolute" style="top: -4rem;">
          Einfach den Standort <br>auf der Karte anklicken!
        </p>
        <h2
          v-if="c.contact !== false"
          class="
            greenUnderline
            subheadline
            d-inline-block
            font-weight-bold
            text-blue
            mb-0
          "
        >
          {{ c.name }}
        </h2>
      </div>

      <div
        v-if="c.contact !== false"
        class="d-flex justify-content-start flex-column mt-3 position-relative"
      >
        <a
          :id="`contact-phone-${c.id}`"
          class="phone-icon d-md-none"
          :href="'tel:' + c.phone"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.99 55.03">
            <g id="Ebene_2" data-name="Ebene 2">
              <g id="Ebene_1-2" data-name="Ebene 1">
                <circle class="cls-1" cx="27.49" cy="27.5" r="26.2" />
                <path
                  class="cls-2"
                  d="M26.09,55A27.52,27.52,0,1,1,55,27.5,27.63,27.63,0,0,1,26.09,55Zm-1-52.3a24.9,24.9,0,0,0,4.5,49.6,25.18,25.18,0,0,0,22.8-22.7A25.06,25.06,0,0,0,25.09,2.7Z"
                />
                <path
                  class="cls-2"
                  d="M41,34.41a1.8,1.8,0,0,0-.19-.2c-.52-.45-1-1-1.5-1.41-.7-.7-1.4-1.3-2.1-2-.6-.5-1.2-1.4-2-1.5a3.12,3.12,0,0,0-1.8.7c-.6.5-1.2.9-1.8,1.4l-.5.4a5.55,5.55,0,0,0-.8.6l-2-2c-1.6-1.6-3.1-3.2-4.7-4.9.6-.6,1.2-1.2,1.9-1.8.4-.4.8-.7,1.2-1.1s.7-.7.7-1.1c.2-1-1-1.8-1.7-2.4s-1.6-1.5-2.4-2.2c-.6-.6-1.2-1.1-1.9-1.7-.5-.4-1-1.1-1.7-1.3a1.09,1.09,0,0,0-.5-.1,4.1,4.1,0,0,0-1.7.7,10.92,10.92,0,0,0-1.7,1.3,11.11,11.11,0,0,0-2.5,3.6,8,8,0,0,0,.8,8.1l.1.1C20,33.5,24,37.4,28,41.3a6.18,6.18,0,0,0,4.2,1.5,9.59,9.59,0,0,0,3.9-.9,10.72,10.72,0,0,0,3.5-2.5,8.05,8.05,0,0,0,1.19-1.65,4.45,4.45,0,0,0,.7-2A2.06,2.06,0,0,0,41,34.41ZM22.79,22.6a19.2,19.2,0,0,1-1.5,1.4,2.22,2.22,0,0,0-.8,1.3,1.19,1.19,0,0,0,.4,1.1L22,27.5c1.1,1.1,2,2,4.5,4.6.8.9,1.5,1.5,2.1,2.2.4.4.7.9,1.2,1a1.27,1.27,0,0,0,.6.1,5.51,5.51,0,0,0,2.3-1.4l.7-.6c.5-.4,1-.8,1.6-1.2a1.38,1.38,0,0,0,.4.3l.5.5c1.1,1,2.2,2.1,3.2,3.1a7.57,7.57,0,0,1-3.8,3.4c-1,.4-3.5,1.3-5.2-.1-4.5-4.4-8.8-8.7-13.6-13.6a5.33,5.33,0,0,1-.4-5.4,7.83,7.83,0,0,1,3.2-3.7c1.8,1.5,3.5,3.1,5,4.4Z"
                />
              </g>
            </g>
          </svg>
        </a>

        <div class="location-address">
          <p class="mb-0 text-blue font-weight-bold">
            {{ c.contact }}
          </p>
            <div class="d-none d-md-block my-2">       
                <a class="text-black font-weight-bold" :id="`contact-phone-dt-${c.id}`" :href="'tel:' + c.phone" >
                    {{ c.phone }}
                </a>
            </div>

          <p class="mb-0">{{ c.office }}</p>
          <p class="mb-0">{{ c.street }}</p>
          <p class="mb-3">{{ c.address }}</p>
        </div>
      </div>

      <div
        class="
          w-100
          mt-2
          d-flex
          justify-content-center justify-content-md-start
          flex-wrap
        "
      >
        <a
          :href="`/termin?loc=${c.name}`"
          class="btn btn-primary text-uppercase font-weight-bold"
          :disabled="c.contact == false"
          >Jetzt anfragen</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    c: Object,
    isMobile: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.phone-icon {
  position: absolute;
  right: 0;
  top: -35px;
  > svg {
    width: 50px;
    height: 50px;
    .cls-1 {
      fill: #fff;
    }
    .cls-2 {
      fill: #005c9c;
    }
  }
}
@media screen and (min-width: 768px) {
  .location-card {
    max-width: 310px;
  }
}

@media screen and (max-width: 480px) {
  .location-address > p {
    font-size: 14px;
    line-height: 20px;
  }
}

@media screen and (max-width: 767px) {
  .location-card {
    border-radius: 7px;
    box-shadow: 0px 0px 10px -4px #bfbfbf;
  }
}
</style>